import { SERVICE_DATA } from './ServiceConstant';

export const NavbarMenu = [
  {
    name: 'Home',
    url: '/',
    tab: 'home',
  },
  {
    name: 'Services',
    url: '/services',
    tab: 'services',
    subMenu: SERVICE_DATA.map((service) => ({
      name: service.title,
      url: `/services/${service.id}`,
      tag: service.id,
    })),
  },
  {
    name: 'Industries',
    url: '/industries',
    tab: 'industries',
    subMenu: [
      { name: 'FinTech', url: '/industries/fintech', tag: 'fintech' },
      { name: 'EdTech', url: '/industries/edtech', tag: 'edtech' },
      { name: 'E-Commerce', url: '/industries/ecommerce', tag: 'ecommerce' },
      { name: 'Logistics', url: '/industries/logistics', tag: 'logistics' },
      { name: 'Retail', url: '/industries/retail', tag: 'retail' },
      {
        name: 'Healthcare',
        url: '/industries/healthcare',
        tag: 'healthcare',
      },
      {
        name: 'Real Estate',
        url: '/industries/realestate',
        tag: 'realestate',
      },
      {
        name: 'Travel & Hospitality',
        url: '/industries/travel',
        tag: 'travel',
      },
    ],
  },
  // {
  //   name: 'Projects',
  //   url: '/projects',
  //   tab: 'projects',
  //   subMenu: [
  //     { name: 'Prasad Eye Hospital', url: '/projects/peh', tag: 'peh' },
  //     {
  //       name: 'NextGen Techno Private Ltd',
  //       url: '/projects/nextgen-techno',
  //       tag: 'nextgen-techno',
  //     },
  //   ],
  // },
  // { name: 'About', url: '/about', tab: 'about' },
  { name: 'Blogs', url: '/blogs', tab: 'blogs' },
];
